/* JST Competition – Experience Days booking (AQ Pro add-on). No app needed. */
(function () {
  'use strict';
  if (window.__xdInit) return;
  window.__xdInit = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var KEY = 'xd-course';
  var routes = (window.theme && window.theme.routes) || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function store(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ymd(d) { return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); }

  /* ---------- Upcoming dates: hide past dates, circuit filter, course highlight ---------- */
  function initDates(scope) {
    $$('[data-xd-dates]', scope).forEach(function (w) {
      if (w.dataset.xdBound) return;
      w.dataset.xdBound = '1';
      var cut = parseInt(w.getAttribute('data-cutoff') || '0', 10) || 0;
      var limit = new Date(); limit.setDate(limit.getDate() + cut);
      var min = ymd(limit);
      // the page can be cached by Shopify, so double check past dates in the browser
      $$('[data-xd-date]', w).forEach(function (c) {
        var d = parseInt(c.getAttribute('data-xd-date'), 10);
        if (d && d < min) { c.hidden = true; c.setAttribute('data-xd-past', '1'); }
      });
      $$('[data-xd-filter]', w).forEach(function (b) {
        b.addEventListener('click', function () { filter(w, b.getAttribute('data-xd-filter')); });
      });
      $$('[data-xd-filter-link]', w).forEach(function (a) {
        a.addEventListener('click', function () { filter(w, a.getAttribute('data-xd-filter-link')); });
      });
      refreshEmpty(w);
      var pref = read(KEY); if (pref) highlight(pref);
    });
  }
  function filter(w, val) {
    $$('[data-xd-filter]', w).forEach(function (b) {
      var on = b.getAttribute('data-xd-filter') === val;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-xd-date]', w).forEach(function (c) {
      if (c.getAttribute('data-xd-past')) return;
      c.hidden = !(val === 'all' || c.getAttribute('data-xd-circuit') === val);
    });
    refreshEmpty(w);
  }
  function refreshEmpty(w) {
    var empty = $('[data-xd-empty]', w); if (!empty) return;
    var any = $$('[data-xd-date]', w).some(function (c) { return !c.hidden; });
    empty.hidden = any;
  }
  function highlight(course) {
    $$('[data-xd-date]').forEach(function (c) {
      var has = (c.getAttribute('data-xd-courses') || '').indexOf('|' + course + '|') > -1;
      c.classList.toggle('is-match', has);
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-xd-course]');
    if (link) { store(KEY, link.getAttribute('data-xd-course')); highlight(link.getAttribute('data-xd-course')); }

    var opener = e.target.closest('[data-xd-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-xd-open'));
      if (dlg) { e.preventDefault(); openDialog(dlg); }
      return;
    }
    if (e.target.closest('[data-xd-close]')) {
      var d = e.target.closest('dialog'); if (d) d.close();
      return;
    }
    // click on the dark backdrop closes the dialog
    if (e.target.matches && e.target.matches('dialog.xd-dialog')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });

  function openDialog(dlg) {
    var form = $('[data-xd-form]', dlg);
    if (form) {
      initForm(form);
      var pref = read(KEY);
      if (pref && !$('input[name="course"]:checked', form)) {
        var r = $$('input[name="course"]', form).filter(function (i) { return i.value === pref && !i.disabled; })[0];
        if (r) { r.checked = true; form._xdUpdate(); }
      }
    }
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; }, { once: true });
    var first = $('input:not([disabled]), button', dlg); if (first && window.matchMedia('(hover: hover)').matches) first.focus();
  }

  /* Date and time the terms were accepted, in UK time, for the booking record */
  function acceptedAt() {
    var d = new Date();
    try { return d.toLocaleString('en-GB', { timeZone: 'Europe/London', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) + ' UK time'; }
    catch (e) { return d.toISOString(); }
  }

  /* ---------- Booking form ---------- */
  function initForm(form) {
    if (form._xdUpdate) return;
    var data; try { data = JSON.parse($('[data-xd-data]', form).textContent); } catch (err) { return; }
    var wrap = form.closest('[data-xd-booking]');
    var total = $('[data-xd-total]', form);
    var errBox = $('[data-xd-error]', form);
    var hasKart = !!$('input[name="kart"]', form);
    var spacesLeft = typeof data.spaces === 'number' ? data.spaces : -1;
    /* Spaces per kart category, shared by every course on this date */
    var kartSpaces = data.kart_spaces || {};
    var perKart = Object.keys(kartSpaces).length > 0;
    function ks(kart) { return kartSpaces[String(kart || '').trim().toLowerCase()] || null; }
    function kartLeft(kart) { var k = ks(kart); if (!k) return perKart ? 0 : -1; if (!k.available) return 0; return k.qty; }
    if (perKart) {
      spacesLeft = 0; var unknown = false;
      Object.keys(kartSpaces).forEach(function (k) { var q = kartLeft(k); if (q < 0) unknown = true; else spacesLeft += q; });
      if (unknown) spacesLeft = -1;
    }
    var notes = {}; (data.course_notes || []).forEach(function (n) { notes[n.course] = n.text; });
    var noteBox = $('[data-xd-course-note]', form), noteText = $('[data-xd-course-note-text]', form);

    function val(name) { var i = $('input[name="' + name + '"]:checked', form); return i ? i.value : null; }
    function find(course, kart) {
      return data.variants.filter(function (v) { return v.course === course && (!hasKart || v.kart === kart); })[0];
    }
    function canBook(v) { return !!(v && v.available && (!perKart || kartLeft(v.kart) !== 0)); }
    function update() {
      var course = val('course');
      $$('input[name="course"]', form).forEach(function (inp) {
        if (!perKart) return;
        var ok = data.variants.some(function (x) { return x.course === inp.value && canBook(x); });
        inp.disabled = !ok; inp.closest('.xd-opt').classList.toggle('is-disabled', !ok);
        if (!ok && inp.checked) { inp.checked = false; course = null; }
        var p = $('.xd-opt__price', inp.closest('.xd-opt'));
        if (p) { if (p._orig == null) p._orig = p.innerHTML; p.innerHTML = ok ? p._orig : 'Full'; }
      });
      $$('input[name="kart"]', form).forEach(function (inp) {
        var label = inp.closest('.xd-opt'), price = $('[data-xd-kart-price]', label), left = $('[data-xd-kart-left]', label);
        var v = course ? find(course, inp.value) : null;
        var any = data.variants.some(function (x) { return x.kart === inp.value && canBook(x); });
        var ok = course ? canBook(v) : any;
        inp.disabled = !ok;
        if (!ok && inp.checked) inp.checked = false;
        var q = perKart ? kartLeft(inp.value) : -1;
        if (left) left.textContent = q === 0 ? 'Sold out' : (q > 0 ? q + ' left' : '');
        if (left) left.classList.toggle('is-out', q === 0);
        if (price) price.textContent = course ? (v ? (ok ? v.price_fmt : (q === 0 ? 'Sold out' : 'Full')) : 'n/a') : '';
      });
      if (noteBox) {
        var t = course ? notes[String(course).trim().toLowerCase()] : null;
        noteBox.hidden = !t; if (t) noteText.innerHTML = t;
      }
      /* ARKS starter pack line in the key terms box */
      $$('[data-xd-key-arks]', form).forEach(function (el) { el.hidden = !(course && /arks/i.test(course)); });
      var v = course ? find(course, val('kart')) : null;
      var box = total.closest('.xd-total');
      if (canBook(v)) { total.textContent = v.price_fmt; box.classList.add('is-set'); }
      else { total.textContent = course ? (hasKart ? 'Select kart category' : 'Unavailable') : 'Select course and kart'; box.classList.remove('is-set'); }
      return v;
    }
    form._xdUpdate = update;
    form.addEventListener('change', function (e) {
      if (e.target.name === 'course' || e.target.name === 'kart') update();
      var f = e.target.closest('.xd-field, .xd-check'); if (f) f.classList.remove('is-invalid');
    });
    update();

    function fail(msg, el) {
      errBox.textContent = msg; errBox.hidden = false;
      if (el) { var f = el.closest('.xd-field, .xd-check, .xd-step'); if (f) f.classList.add('is-invalid'); el.focus({ preventScroll: true }); (f || el).scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errBox.hidden = true;
      $$('.is-invalid', form).forEach(function (x) { x.classList.remove('is-invalid'); });
      var course = val('course');
      if (!course) return fail('Please select a course.', $('input[name="course"]:not([disabled])', form));
      if (hasKart && !val('kart')) return fail('Please select the driver age / kart category.', $('input[name="kart"]:not([disabled])', form));
      var v = update();
      if (!canBook(v)) return fail(perKart && v && kartLeft(v.kart) === 0 ? 'Sorry, there are no ' + v.kart + ' spaces left on this date. Please choose another kart category or date.' : 'Sorry, that course and kart combination is not available on this date.');
      var req = $$('[required]', form).filter(function (i) { return i.name !== 'course' && i.name !== 'kart'; });
      for (var i = 0; i < req.length; i++) {
        var el = req[i];
        var empty = el.type === 'checkbox' ? !el.checked : !String(el.value || '').trim();
        if (empty || (el.checkValidity && !el.checkValidity())) {
          var lbl = el.closest('label'); var name = lbl ? (lbl.querySelector('span') || lbl).textContent.replace('*', '').trim() : 'This field';
          return fail(el.type === 'checkbox' ? 'Please tick to confirm: ' + name : 'Please complete: ' + name, el);
        }
      }
      var fd = new FormData(form);
      var id = 'XD' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase();
      var driver = String(fd.get('driver_name') || '').trim();
      var props = { '_xd': id, 'Experience date': data.date, 'Circuit': data.circuit, 'Driver name': driver,
        'Driver age on the day': String(fd.get('driver_age') || '').trim(), 'Height': String(fd.get('height') || '').trim(),
        'Weight': String(fd.get('weight') || '').trim(), 'Previous experience': String(fd.get('experience') || '').trim() };
      var notes = String(fd.get('notes') || '').trim(); if (notes) props['Notes'] = notes;
      if (form.elements.terms) {
        props['_Booking terms accepted'] = 'Yes';
        if (data.terms_version) props['_Terms version'] = data.terms_version;
        props['_Terms accepted at'] = acceptedAt();
      }
      if (form.elements.kit) props['_Safety kit acknowledged'] = 'Yes';
      var items = [{ id: v.id, quantity: 1, properties: props }];
      var spaceVar = perKart ? ks(v.kart) : data.space;
      if (spaceVar && spaceVar.id) items.push({ id: spaceVar.id, quantity: 1, properties: { '_xd': id, '_xd_role': 'space', 'Driver': driver } });

      var btn = $('[data-xd-submit]', form); btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
      fetch((routes.cartAdd || root + 'cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: cartSections(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) {
            var m = (res.j && (res.j.description || res.j.message)) || '';
            var full = (res.j && res.j.status === 422) || /sold out|can.?t add|only add|already|stock|inventory|available/i.test(m);
            if (full && perKart) { var kk = ks(v.kart); if (kk) kk.qty = 0; update(); }
            fail(full ? (perKart ? 'Sorry, there are no ' + v.kart + ' spaces left on this date. Please choose another kart category or date.' : 'Sorry, there are no driver spaces left on this date. Please choose another date or register your interest.') : (m || 'Something went wrong. Please try again.'));
            return;
          }
          if (spacesLeft > 0) spacesLeft--;
          if (perKart) { var kq = ks(v.kart); if (kq && kq.qty > 0) kq.qty--; update(); }
          refreshCart(res.j && res.j.sections);
          if (data.after === 'checkout') { window.location.href = root + 'checkout'; return; }
          if (data.after === 'cart') { window.location.href = routes.cart || root + 'cart'; return; }
          var ok = $('[data-xd-success]', wrap);
          $('[data-xd-success-text]', ok).textContent = driver + ' – ' + course + (hasKart ? ' (' + val('kart') + ')' : '') + ' – ' + data.date + ', ' + data.circuit + '.';
          var another = $('[data-xd-another]', ok); if (another) another.hidden = spacesLeft === 0;
          form.hidden = true; ok.hidden = false;
          var dlg = form.closest('dialog'); if (dlg) dlg.scrollTop = 0;
          ok.setAttribute('tabindex', '-1'); ok.focus({ preventScroll: true });
        })
        .catch(function () { fail('Connection problem. Please check your internet and try again.'); })
        .finally(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; });
    });

    var another = $('[data-xd-another]', wrap);
    if (another) another.addEventListener('click', function () {
      ['driver_name', 'driver_age', 'height', 'weight', 'notes'].forEach(function (n) { var f = form.elements[n]; if (f) f.value = ''; });
      if (form.elements.experience) form.elements.experience.value = '';
      $('[data-xd-success]', wrap).hidden = true; form.hidden = false;
      var dn = form.elements.driver_name; if (dn) dn.focus();
    });
  }

  /* Cart drawer: re-render it after a booking is added (same sections the theme uses) */
  function cartSections() {
    var list = ['cart-drawer'];
    $$('[data-cart-count-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-count-section'); if (id && list.indexOf(id) < 0) list.push(id);
    });
    return list;
  }
  function renderCart(sections) {
    var html = sections && sections['cart-drawer'];
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('[data-cart-drawer-inner]'), dest = document.querySelector('[data-cart-drawer-inner]');
    if (src && dest) dest.innerHTML = src.innerHTML;
    var drawerSrc = doc.querySelector('[data-cart-drawer]'), drawer = document.querySelector('[data-cart-drawer]');
    var count = drawerSrc ? drawerSrc.getAttribute('data-count') : null;
    if (count !== null) {
      if (drawer) drawer.setAttribute('data-count', count);
      $$('[data-cart-count]').forEach(function (c) { c.textContent = count; c.setAttribute('data-count', count); });
    }
    return true;
  }
  function refreshCart(sections) {
    if (renderCart(sections)) return;
    fetch(root + '?sections=' + cartSections().join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-xd-view-cart]');
    if (!link) return;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.themeDrawer || typeof window.themeDrawer.open !== 'function') return;
    e.preventDefault();
    var dlg = link.closest('dialog'); if (dlg && dlg.open) dlg.close();
    window.themeDrawer.open(drawer);
  });

  /* Remove booking in the cart drawer (needed when the drawer was refreshed without a page load) */
  if (!window.__xdCart) {
    window.__xdCart = true;
    var UPDATE_URL = routes.cartUpdate || root + 'cart/update';
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-xd-remove]'); if (!b) return;
      e.preventDefault(); if (b.disabled) return; b.disabled = true;
      var onPage = !!b.closest('[data-cart-page]');
      var drawer = document.getElementById('CartDrawer');
      var sections = ['cart-drawer'];
      document.querySelectorAll('[data-cart-count-section]').forEach(function (el) {
        var s = el.getAttribute('data-cart-count-section'); if (s && sections.indexOf(s) < 0) sections.push(s);
      });
      var u = {}; b.getAttribute('data-xd-remove').split(',').forEach(function (k) { if (k) u[k] = 0; });
      if (drawer) drawer.classList.add('is-loading');
      fetch(UPDATE_URL + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: u, sections: sections, sections_url: window.location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = !onPage && j && j.sections && j.sections['cart-drawer'];
          if (!html) { window.location.reload(); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('[data-cart-drawer-inner]'), dest = document.querySelector('[data-cart-drawer-inner]');
          if (src && dest) dest.innerHTML = src.innerHTML;
          var ds = doc.querySelector('[data-cart-drawer]'), count = ds ? ds.getAttribute('data-count') : null;
          if (count !== null) {
            var d = document.querySelector('[data-cart-drawer]'); if (d) d.setAttribute('data-count', count);
            document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = count; c.setAttribute('data-count', count); });
          }
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { b.disabled = false; if (drawer) drawer.classList.remove('is-loading'); });
    });
  }

  function boot(scope) {
    initDates(scope || document);
    $$('[data-xd-booking] [data-xd-form]', scope || document).forEach(function (f) { if (!f.closest('dialog')) initForm(f); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* XD Photo gallery: carousel arrows and full screen viewer (Oct 28) */
(function () {
  'use strict';
  if (window.__xdGalleryInit) return;
  window.__xdGalleryInit = true;

  function initGallery(g) {
    if (g.__xdg) return;
    g.__xdg = true;
    var track = g.querySelector('[data-xd-track]');
    var prev = g.querySelector('[data-xd-prev]');
    var next = g.querySelector('[data-xd-next]');
    var bar = g.querySelector('[data-xd-progress]');

    /* Carousel */
    if (track && g.classList.contains('xd-gallery--carousel')) {
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) {
          var w = track.scrollWidth ? Math.max(track.clientWidth / track.scrollWidth, 0.08) : 1;
          bar.style.width = (w * 100) + '%';
          bar.style.marginLeft = (max > 0 ? (track.scrollLeft / max) * (1 - w) * 100 : 0) + '%';
          bar.parentNode.style.visibility = max > 2 ? '' : 'hidden';
        }
      };
      var step = function (dir) {
        track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.85, 200), behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
      window.addEventListener('resize', update);
      track.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', update, { once: true }); });
      update();
    }

    /* Video row: load when near the screen, play muted while visible */
    var vids = Array.prototype.slice.call(g.querySelectorAll('video[data-src]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = [];
    var tilePlay = function (v) {
      if (!v.hasAttribute('data-xd-autoplay') || reduce || g.__xdLbOpen) return;
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    };
    var loadVid = function (v) {
      if (v.getAttribute('src')) return;
      v.preload = v.hasAttribute('data-xd-autoplay') && !reduce ? 'auto' : 'metadata';
      v.src = v.getAttribute('data-src');
    };
    vids.forEach(function (v) {
      var li = v.closest('.xd-gallery__vitem');
      v.muted = true;
      v.addEventListener('loadedmetadata', function () {
        if (li && li.hasAttribute('data-xd-auto-ar') && v.videoWidth && v.videoHeight) li.style.setProperty('--ar', (v.videoWidth / v.videoHeight).toFixed(4));
      });
      v.addEventListener('playing', function () { if (li) li.classList.add('is-playing'); });
      v.addEventListener('pause', function () { if (li) li.classList.remove('is-playing'); });
    });
    if (vids.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) {
              if (visible.indexOf(v) < 0) visible.push(v);
              loadVid(v); tilePlay(v);
            } else {
              visible = visible.filter(function (x) { return x !== v; });
              if (!v.paused && v.muted) v.pause();
            }
          });
        }, { rootMargin: '200px 0px' });
        vids.forEach(function (v) { io.observe(v); });
      } else {
        vids.forEach(function (v) { loadVid(v); visible.push(v); tilePlay(v); });
      }
    }
    /* Lightbox off: click a video to play it there with sound */
    Array.prototype.slice.call(g.querySelectorAll('[data-xd-vtoggle]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.querySelector('video'), li = b.closest('.xd-gallery__vitem');
        loadVid(v);
        if (v.muted || v.paused) { v.muted = false; v.controls = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); if (li) li.classList.add('is-sound'); }
      });
    });

    /* Full screen viewer */
    var lb = g.querySelector('[data-xd-lightbox]');
    var openers = Array.prototype.slice.call(g.querySelectorAll('[data-xd-photo]'));
    if (!lb || !openers.length) return;
    if (lb.parentNode !== document.body) document.body.appendChild(lb); // escape transforms and overflow
    var img = lb.querySelector('[data-xd-lb-img]');
    var lbv = lb.querySelector('[data-xd-lb-video]');
    var cap = lb.querySelector('[data-xd-lb-cap]');
    var count = lb.querySelector('[data-xd-lb-count]');
    var idx = 0, lastFocus = null;

    function show(i) {
      idx = (i + openers.length) % openers.length;
      var b = openers[idx];
      var isVid = b.getAttribute('data-type') === 'video';
      if (lbv) { lbv.pause(); if (!isVid) { lbv.removeAttribute('src'); lbv.load(); } lbv.hidden = !isVid; }
      img.hidden = isVid;
      if (isVid && lbv) {
        lbv.src = b.getAttribute('data-full');
        lbv.muted = false;
        var tv = b.querySelector('video');
        if (tv && tv.getAttribute('poster')) lbv.poster = tv.getAttribute('poster'); else lbv.removeAttribute('poster');
        var pr = lbv.play(); if (pr && pr.catch) pr.catch(function () {});
      } else {
        var thumb = b.querySelector('img');
        img.classList.add('is-loading');
        img.onload = function () { img.classList.remove('is-loading'); };
        img.src = b.getAttribute('data-full');
        img.alt = (thumb && thumb.alt) || '';
      }
      cap.textContent = b.getAttribute('data-caption') || '';
      count.textContent = (idx + 1) + ' / ' + openers.length;
      [idx + 1, idx - 1].forEach(function (n) { var o = openers[(n + openers.length) % openers.length]; if (o && o.getAttribute('data-type') !== 'video') { var p = new Image(); p.src = o.getAttribute('data-full'); } });
    }
    function open(i) {
      lastFocus = document.activeElement;
      g.__xdLbOpen = true;
      vids.forEach(function (v) { if (!v.paused) v.pause(); });
      show(i);
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
      document.documentElement.classList.add('xd-lb-lock');
    }
    function close() { if (lb.open) { if (typeof lb.close === 'function') lb.close(); else lb.removeAttribute('open'); } }

    openers.forEach(function (b, i) { b.addEventListener('click', function (e) { e.preventDefault(); open(i); }); });
    lb.addEventListener('close', function () {
      document.documentElement.classList.remove('xd-lb-lock');
      if (lbv) { lbv.pause(); lbv.removeAttribute('src'); lbv.load(); lbv.hidden = true; }
      g.__xdLbOpen = false;
      visible.forEach(tilePlay);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-xd-lb-close]')) return close();
      if (e.target.closest('[data-xd-lb-prev]')) return show(idx - 1);
      if (e.target.closest('[data-xd-lb-next]')) return show(idx + 1);
      if (e.target === lb || e.target.classList.contains('xd-lightbox__stage')) close();
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
    });
    var sx = null, sy = null;
    lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && openers.length > 1) show(idx + (dx < 0 ? 1 : -1));
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
      sx = sy = null;
    });
    g.__xdLb = lb;
  }

  function boot(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-xd-gallery]')).forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.slice.call(e.target.querySelectorAll('[data-xd-gallery]')).forEach(function (g) { if (g.__xdLb && g.__xdLb.parentNode) g.__xdLb.parentNode.removeChild(g.__xdLb); });
  });
})();
